import script from "./Coupons.vue?vue&type=script&setup=true&lang=js"
export * from "./Coupons.vue?vue&type=script&setup=true&lang=js"

import "./Coupons.vue?vue&type=style&index=0&id=63066236&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63066236"]])

export default __exports__